export default __webpack_public_path__ + "static/media/playerEntry.43377987.jpg";